<template>
    <Navbar :tabs="tabs" :dropdown-tabs="dropdownTabs" :currentApp="'ia'"></Navbar>
</template>

<script>
import Navbar from '../Navbar.vue';
import ReportHistoryView from './ReportHistoryView.vue';
import AbsenceCalendar from './AbsenceCalendar.vue';
import WorktimePlan from './WorktimePlan.vue';
import WorkSummary from './WorkSummary.vue';
import EditProfile from './EditProfile.vue';
import Employees from './Employees.vue';

const DOC_TITLE = document.title;

export default {
    components: {
        Navbar
    },
    data() {
        return {
            tabs: [
                {
                    name: 'Raporty',
                    component: ReportHistoryView,
                    showIf: this.needsAuthentication,
                    defaultTab: true,
                },
                {
                    name: 'Urlopy',
                    component: AbsenceCalendar,
                    showIf: this.needsAuthentication,
                },
                {
                    name: 'Plan pracy',
                    component: WorktimePlan,
                    showIf: this.needsAuthentication,
                },
                {
                    name: 'Pracownicy',
                    component: Employees,
                    showIf: this.needsAuthentication,
                },
                {
                    name: 'Statystyki',
                    component: WorkSummary,
                    showIf: this.needsAuthentication,
                }
            ],
            dropdownTabs: [
                {
                    name: 'Edytuj profil',
                    component: EditProfile,
                    showIf: this.needsAuthentication,
                },
            ],
        }
    },
    methods: {
        needsAuthentication: function () {
            return this.$store.getters['auth/authenticated'];
        },
        getTimeString(minutes) {
            if (moment().add(-minutes, 'minutes') < moment().startOf('day'))
                return "!";
            else
                return this.$store.getters['ia/workingTimeMoment'].format('H:mm');
        },
    },
    computed: {
        workingTime() {
            return this.$store.getters['ia/workingTimeMinutes'];
        }
    },
    watch: {
        workingTime() {
            document.title = this.workingTime !== null ? DOC_TITLE + ' (' + this.getTimeString(this.workingTime) + ')': DOC_TITLE;
        }
    },
    beforeDestroy() {
        document.title = DOC_TITLE;
    },
}
</script>

<style lang="css">
@import '~vuesax/dist/vuesax.css';
@import '~material-icons/iconfont/material-icons.css';
</style>

<style lang="scss">
@import '~bootstrap/scss/bootstrap.scss';
</style>



// WEBPACK FOOTER //
// IaApp.vue?8033cd46